import ApplicationController from './application_controller';
import { debounce } from 'lodash-es';

export default class extends ApplicationController {
  static targets = [];
}
